<template>
	<div>
		<card class="card-stats" :show-footer-line="true" :body-classes="color">
			<b-row slot="header">
				<b-col>
					<span class="h3 font-weight-bold mb-0" v-if="title">{{ title }}</span>
				</b-col>

				<b-col v-if="$slots.icon || icon" class="text-right pl-0 pr-2">
					<span class="h5 font-weight-bold mb-0" v-if="activity">
						<b-badge
							variant="success"
							class="m-1 cursor-pointer border-non-radius"
							:class="activeState ? 'bg-green text-white' : 'border-red text-dark'"
							v-on:click="activateSubscriberOpen(imsi)"
						>
							<i class="fa fa-play" :class="activeState ? 'text-white' : 'text-dark'"></i>
							{{ activity }}
						</b-badge>
					</span>
					<span class="h5 font-weight-bold mb-0 1" v-if="modify" style="display: none">
						<b-badge
							variant="light"
							class="m-1 cursor-pointer border-non-radius"
							:class="modifyState ? 'bg-orange text-white' : 'border-red text-dark'"
							v-on:click="modifySubscriberOpen(imsi)"
						>
							<i class="fa fa-pen" :class="modifyState ? 'text-white' : 'text-dark'"></i>
							{{ modify }}
						</b-badge>
					</span>
					<span class="h5 font-weight-bold mb-0" v-if="suspend">
						<b-badge
							variant="light"
							class="m-1 cursor-pointer border-non-radius"
							:class="suspendState ? 'bg-yellow text-danger' : 'border-red text-dark'"
							v-on:click="suspendSubscriberOpen(imsi)"
						>
							<i class="fa fa-stop" :class="suspendState ? 'text-danger' : 'text-dark'"></i>
							{{ suspend }}
						</b-badge>
					</span>
					<span class="h5 font-weight-bold mb-0" v-if="resume">
						<b-badge
							variant="light"
							class="m-1 cursor-pointer border-non-radius"
							:class="resumeState ? 'bg-blue text-white' : 'border-red text-dark'"
							v-on:click="resumeSubscriberOpen(imsi)"
						>
							<i class="fa fa-sync" :class="resumeState ? 'text-white' : 'text-dark'"></i>
							{{ resume }}
						</b-badge>
					</span>
					<span class="h5 font-weight-bold mb-0" v-if="terminate">
						<b-badge
							variant="light"
							class="m-1 cursor-pointer border-non-radius"
							:class="terminateState ? 'bg-red text-white' : 'border-red text-dark'"
							v-on:click="terminateSubscriberOpen(imsi)"
						>
							<i class="fa fa-ban" :class="terminateState ? 'text-white' : 'text-dark'"></i>
							{{ terminate }}
						</b-badge>
					</span>
					<slot name="icon" class="pl-2">
            <b-icon
                icon="question-circle"
                variant="orange"
                class="mr-1 vertical-align-35"
                v-b-tooltip.hover.top="tooltip">
            </b-icon>
					</slot>
				</b-col>
			</b-row>

			<p class="mt-1 mb-0 text-sm">
				<slot name="footer"> </slot>
			</p>
		</card>

		<b-modal
			scrollable
			centered
			size="lg"
			id="activate-subscriber"
			hide-footer
			title="Activate Subscriber"
			class="activate-subscriber"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<ActivateSubscriber></ActivateSubscriber>
		</b-modal>

		<b-modal
			scrollable
			centered
			size="lg"
			id="activate-subscriber-simple"
			hide-footer
			title="Activate Subscriber"
			class="activate-subscriber-simple"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
			:isNsim="isNsim"
		>
			<ActivateSubscriberSimple></ActivateSubscriberSimple>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="suspend-subscriber"
			hide-footer
			title="Suspend Subscriber"
			class="suspend-subscriber"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<SuspendSubscriber></SuspendSubscriber>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="resume-subscriber"
			hide-footer
			title="Resume Subscriber"
			class="resume"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<ResumeSubscriber></ResumeSubscriber>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="terminate-subscriber"
			hide-footer
			title="Terminate Subscriber"
			class="terminate-subscriber"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<TerminateSubscriber></TerminateSubscriber>
		</b-modal>
	</div>
</template>

<script>
import SuspendSubscriber from "../../Components/Provisioning-Suspend-Subscriber";
import TerminateSubscriber from "../../Components/Provisioning-Terminate-Subscriber";
import ActivateSubscriber from "../../Components/Provisioning-Activate-Subscriber";
import ActivateSubscriberSimple from "../../Components/Provisioning-Activate-Subscriber-Simple";
import ResumeSubscriber from "../../Components/Provisioning-Resume-Subscriber";
import configDirective from "../../../common/directive/config-directive";
import provisioningService from "../../../common/api-services/provisioning-service";

export default {
	name: "State",
	components: {
		ActivateSubscriber,
		ActivateSubscriberSimple,
		TerminateSubscriber,
		SuspendSubscriber,
		ResumeSubscriber,
	},
	props: {
		type: {
			type: String,
			default: "primary",
		},
		tabId: String,
		icon: String,
		title: String,
		activity: String,
		modify: String,
		suspend: String,
		resume: String,
		terminate: String,
		iconClasses: [String, Array],
		color: String,
		tooltip: String,
		isNsim: Boolean,
		imsi: String,
		iccid: String,
		activeState: Boolean,
		modifyState: Boolean,
		suspendState: Boolean,
		resumeState: Boolean,
		terminateState: Boolean,
	},
	data() {
		return {};
	},
	mounted() {},
	methods: {
		openSimpleActivate() {
			this.$bvModal.show("activate-subscriber-simple");
		},
		activateSubscriberOpen(imsi) {
			if (!this.activeState) return;
			const isIOTOnly = configDirective.isIOTOnly();
			setTimeout(() => {
				this.$root.$emit("sendIMSIInfo", imsi);
				this.$root.$emit("sendICCIDInfo", this.iccid);
			}, 1000);
			if (isIOTOnly) {
				this.openSimpleActivate();
				return;
			}
			this.$bvModal.show("activate-subscriber");
		},

		modifySubscriberOpen(imsi) {
			if (this.modifyState) {
				this.$bvModal.show("activate-subscriber");
				setTimeout(() => {
					this.$root.$emit("sendIMSIInfo", imsi);
				}, 1000);
			}
		},

		suspendSubscriberOpen(imsi) {
			if (this.suspendState) {
				this.$bvModal.show("suspend-subscriber");
				setTimeout(() => {
					this.$root.$emit("sendIMSIInfo", imsi);
				}, 1000);
			}
		},

		resumeSubscriberOpen(imsi) {
			if (this.resumeState) {
				this.$bvModal.show("resume-subscriber");
				setTimeout(() => {
					this.$root.$emit("sendIMSIInfo", imsi);
				}, 1000);
			}
		},

		terminateSubscriberOpen(imsi) {
			if (this.terminateState) {
				this.$bvModal.show("terminate-subscriber");
				setTimeout(() => {
					this.$root.$emit("sendIMSIInfo", imsi);
				}, 1000);
			}
		},
	},
};
</script>
